import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  "& ul": {
    listStyle: "none",
    margin: "20px 0",
    padding: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    "@media (max-width:874px)": {
      flexDirection: "column",
      flexWrap: "wrap",
    },
    "& > li": {
      width: "calc(50% - 10px)",
      border: "#211F45 2px solid",
      borderRadius: "12px",
      padding: "20px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        background: "#021C64",
        borderColor: "#01ECFF",
        "& > p": {
          color: "#fff"
        },
        "& ol": {
          borderColor: "#fff",
        },
        "& ol > li strong": {
          color: "#01ECFF"
        },
        "& .delete-sim-btn": {
          background: "#030039"
        }
      },
      "@media (max-width:874px)": {
        width: "100%",
      },
      "& h3": {
        margin: "0",
        fontWeight: "600",
        fontSize: "17px",
      },
      "& > p": {
        margin: "0 0 15px 0",
        fontSize: "13px",
        color: "#717680",
      },
      "& ol": {
        listStyle: "none",
        margin: "0 0 15px 0",
        padding: "15px 0",
        borderTop: "#211F45 1px solid",
        borderBottom: "#211F45 1px solid",
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        "& > li": {
          width: "calc(50% - 5px)",
          fontSize: "14px",
          "& strong": {
            color: "#A87EFF",
            display: "block",
            marginBottom: "3px",
            fontSize: "12px",
          },
        },
      },
      "& .delete-sim-btn": {
        width: "100%",
        padding: "15px",
        "& p": {
          display: "flex",
          alignItems: "center",
          gap: "5px",
        },
      },
    },
  },
}));
